import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
}

function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12">
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      {message && <p className="text-sm text-gray-500">{message}</p>}
    </div>
  );
}

export { LoadingSpinner, type LoadingSpinnerProps };
